export const wrapLines = value => {
  return value.replace(/.+$/gm, '<p>$&</p>');
};
